import React from 'react';

import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

const formName = 'battery-form';

type PeDependOnProps = {
  readonly dependOn: any;
  readonly value?: string;
  readonly formValues: any;
  readonly children: any;
}
const PeDependOn: React.FC<PeDependOnProps> = props => {
  const buildCondition = (con: any, target: any) => {
    if (con === "") {
      return target && target !== "";
    } 
    if (con.indexOf("!") !== -1 ) {
      return target && target !== con.substring(1);
    }
    return target && target === con;
  }

  const checkIsDisplay = () => {
    let isDiplay = true;
    let tmpArr = [];
    try {
      // Check dependOn multiple condition
      let jsonDepend = JSON.parse(props.dependOn);
      for (let key in jsonDepend) {
        // Check dependOn multiple value
        if (jsonDepend[key].indexOf(",") !== -1) {
          tmpArr = jsonDepend[key].split(',');
          for (let index in tmpArr) {
            isDiplay = isDiplay && Boolean(buildCondition(tmpArr[index], props.formValues[key]));
          }
        } else {
          isDiplay = isDiplay && Boolean(buildCondition(jsonDepend[key], props.formValues[key]));
        }
      }
      return isDiplay;
    } catch (error) {
      // Case single condition
      isDiplay = false;
      let dependOnValue = props.formValues ? props.formValues[props.dependOn] : '';
      if (typeof dependOnValue !== 'undefined' && dependOnValue !== '') {
        if (props.value) {
          isDiplay = dependOnValue === props.value;
        } else {
          isDiplay = true;
        }
      }
      return isDiplay;
    }
  }

  return checkIsDisplay() && props.children
}

export default connect(state => ({formValues: getFormValues(formName)(state)}))(PeDependOn);